import { render } from "./SurveyPage10.vue?vue&type=template&id=0ae69fb1&scoped=true"
const script = {}

import "./SurveyPage10.vue?vue&type=style&index=0&id=0ae69fb1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ae69fb1"]])

export default __exports__